export const AUTH_EVENTS = {
  LOGGED_OUT: 'logged_out',
  LOGGED_IN: 'logged_in',
  AUTH_ERROR: 'auth_error',
} as const;
